// src/Map3DComponent.js
import React, { useEffect, useRef, useState } from 'react';

// Singleton per gestire il caricamento dello script Google Maps
let googleMapsScript = null;
let scriptLoadPromise = null;

const loadGoogleMapsScript = (apiKey) => {
  if (scriptLoadPromise) {
    return scriptLoadPromise;
  }

  if (document.querySelector('script[src*="maps.googleapis.com"]')) {
    scriptLoadPromise = Promise.resolve();
    return scriptLoadPromise;
  }

  scriptLoadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=alpha&libraries=maps3d`;
    script.async = true;
    script.onload = () => {
      console.log('Google Maps API script loaded');
      resolve();
    };
    script.onerror = () => {
      console.error('Failed to load Google Maps API script');
      reject(new Error('Failed to load Google Maps API'));
    };
    document.head.appendChild(script);
    googleMapsScript = script;
  });

  return scriptLoadPromise;
};


const Map3DComponent = ({ htkApiMaps }) => {  // Ricevi la chiave API dalle props

  const mapRef = useRef(null); // Riferimento al DOM di gmp-map-3d
  const [isMapReady, setIsMapReady] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const initializeMap = async () => {
      try {
        // Carica lo script Google Maps (singleton)
        await loadGoogleMapsScript(htkApiMaps);

        if (!isMounted) return;

        // Aspetta che l'elemento sia disponibile
        const map3DElement = mapRef.current;
        if (map3DElement) {
          console.log('Map3D element ready');
          setIsMapReady(true);
        }
      } catch (error) {
        console.error('Failed to initialize map:', error);
      }
    };

    initializeMap();

    // Cleanup function
    return () => {
      isMounted = false;
      
      // Pulisci l'elemento della mappa
      const map3DElement = mapRef.current;
      if (map3DElement) {
        try {
          // Rimuovi tutti gli event listeners se attivi
          map3DElement.removeEventListener('gmp-click', handleClickEvent);
          map3DElement.removeEventListener('gmp-centerchange', handleCenterChangeEvent);
          map3DElement.removeEventListener('gmp-headingchange', handleHeadingChangeEvent);
          map3DElement.removeEventListener('gmp-rangechange', handleRangeChangeEvent);
          map3DElement.removeEventListener('gmp-rollchange', handleRollChangeEvent);
          map3DElement.removeEventListener('gmp-steadychange', handleSteadyChangeEvent);
          map3DElement.removeEventListener('gmp-tiltchange', handleTiltChangeEvent);
        } catch (error) {
          console.warn('Event listener cleanup error:', error);
        }

        // Pulisci il ref
        mapRef.current = null;
      }
    };
  }, [htkApiMaps]);

  // useEffect per gestire gli event listeners quando la mappa è pronta
  useEffect(() => {
    if (!isMapReady || !mapRef.current) return;

    const map3DElement = mapRef.current;

    // Aggiungi event listeners solo se necessario
    // map3DElement.addEventListener('gmp-click', handleClickEvent);
    // map3DElement.addEventListener('gmp-centerchange', handleCenterChangeEvent);
    // map3DElement.addEventListener('gmp-headingchange', handleHeadingChangeEvent);
    // map3DElement.addEventListener('gmp-rangechange', handleRangeChangeEvent);
    // map3DElement.addEventListener('gmp-rollchange', handleRollChangeEvent);
    // map3DElement.addEventListener('gmp-steadychange', handleSteadyChangeEvent);
    // map3DElement.addEventListener('gmp-tiltchange', handleTiltChangeEvent);

    console.log('Map3D event listeners attached');

    // Cleanup function
    return () => {
      if (map3DElement) {
        try {
          // Rimuovi event listeners
          // map3DElement.removeEventListener('gmp-click', handleClickEvent);
          // map3DElement.removeEventListener('gmp-centerchange', handleCenterChangeEvent);
          // map3DElement.removeEventListener('gmp-headingchange', handleHeadingChangeEvent);
          // map3DElement.removeEventListener('gmp-rangechange', handleRangeChangeEvent);
          // map3DElement.removeEventListener('gmp-rollchange', handleRollChangeEvent);
          // map3DElement.removeEventListener('gmp-steadychange', handleSteadyChangeEvent);
          // map3DElement.removeEventListener('gmp-tiltchange', handleTiltChangeEvent);
        } catch (error) {
          console.warn('Event listener cleanup error:', error);
        }
      }
    };
  }, [isMapReady]);

  // Funzioni per gestire gli eventi
  const handleClickEvent = (event) => {
    console.log('Click event detected:', event);
  };

  const handleCenterChangeEvent = (event) => {
    console.log('Center change event detected:', event);
  };

  const handleHeadingChangeEvent = (event) => {
    console.log('Heading change event detected:', event);
  };

  const handleRangeChangeEvent = (event) => {
    console.log('Range change event detected:', event);
  };

  const handleRollChangeEvent = (event) => {
    console.log('Roll change event detected:', event);
  };

  const handleSteadyChangeEvent = (event) => {
    console.log('Steady change event detected:', event);
  };

  const handleTiltChangeEvent = (event) => {
    console.log('Tilt change event detected:', event);
  };

  // Cleanup globale quando l'app si chiude
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (googleMapsScript && googleMapsScript.parentNode) {
        try {
          googleMapsScript.parentNode.removeChild(googleMapsScript);
          googleMapsScript = null;
          scriptLoadPromise = null;
        } catch (error) {
          console.warn('Global script cleanup error:', error);
        }
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <div>
      <gmp-map-3d
        mode="hybrid" // nuova aggiunta della libreria, altrimenti non viene visualizzata la mappa 3D
        ref={mapRef}
        center="37.841157, -122.551679" 
        tilt="67.5" 
        style={{ width: '100%', height: '100vh' }}
      ></gmp-map-3d>
    </div>
  );
};

export default Map3DComponent;
